export enum ProcessStatusKind {
    PENDING = 0,
    STARTED = 1,
    EXECUTING = 2,
    FINISHED = 3,
    ERROR = 4
}
